import React, { useEffect } from 'react';

// Global modal fix - ensures all modals can be closed
export const useModalFix = () => {
  useEffect(() => {
    // Add click handler to all modal backdrops
    const handleBackdropClick = (e) => {
      if (e.target.classList.contains('modal')) {
        const closeButton = e.target.querySelector('.btn-close');
        if (closeButton) {
          closeButton.click();
        }
      }
    };

    // Add ESC key handler
    const handleEscKey = (e) => {
      if (e.key === 'Escape') {
        const modals = document.querySelectorAll('.modal.show');
        modals.forEach(modal => {
          const closeButton = modal.querySelector('.btn-close');
          if (closeButton) {
            closeButton.click();
          }
        });
      }
    };

    document.addEventListener('click', handleBackdropClick);
    document.addEventListener('keydown', handleEscKey);

    return () => {
      document.removeEventListener('click', handleBackdropClick);
      document.removeEventListener('keydown', handleEscKey);
    };
  }, []);
};

export default useModalFix;
